import { Block } from './block';

export class Shape {
  public get id() {
    return `shape_${this.shapeNum}`;
  }
  public shapeNum: number;
  public readonly blocks: Block[];

  constructor(blocks: Block[], num: number) {
    this.blocks = blocks;
    this.shapeNum = num;
  }

  public cloneShape(): Shape {
    return new Shape(
      this.blocks.map((block) => new Block(block.posInShape)),
      this.shapeNum,
    );
  }

  public centerGridCoordinates(gridId: string) {
    if (/^\d{2}$/.test(gridId)) {
      const row = Math.max(...this.blocks.map((block) => block.posInShape.row));
      const column = Math.max(...this.blocks.map((block) => block.posInShape.col));

      return { row: parseInt(gridId[0]) + row * 0.5, column: parseInt(gridId[1]) + column * 0.5 };
    } else {
      return { row: 4, column: 4 }; // Center of the grid
    }
  }
}
